import {Typography} from "@material-ui/core";

const NoDataFound = ({title} : any) =>{
    return (
        <Typography className="text-center" variant="h4">
            {title}
        </Typography>
    )
  }

export default NoDataFound;